// extracted by mini-css-extract-plugin
export default {"radio":"JbPB2","input":"_I16A","label":"mRDOx"};